import React, { useEffect, useState } from "react";
import { ProgressBar } from "primereact/progressbar";
import { useLoadState } from "../Hooks/useLoadState";

const HeadLoader = () => {
  const [loading, setLoading] = useState(false);
  const loadingState = useLoadState();

  useEffect(() => {
    let handleTimeout;
    if (loadingState) {
      setLoading(true);
    } else {
      handleTimeout = setTimeout(() => {
        setLoading(loadingState);
      }, 100);
    }
    return () => {
      clearInterval(handleTimeout);
    };
  }, [loadingState]);
  
  return (
    <ProgressBar
      mode="indeterminate"
      pt={{
        value: {
          style: { background: "#0f3c91" },
        },
      }}
      className="header-loading-progress"
      style={{
        height: loading ? "2px" : 0,
        position: "absolute",
        width: "100%",
        bottom: 0,
      }}
    ></ProgressBar>
  );
};

export default HeadLoader;
